import React from "react";
import {Box, Button, MenuItem, TextField, Typography} from "@mui/material";
import {COUPON_STATUSES, couponLifecycle} from "./coupon-lifecycle";

export default function CouponCampaignFilters({coupons, visible, now, search, status, setSearch, setStatus, t}) {
    const count = value => value === "ALL" ? coupons.length : coupons.filter(coupon => couponLifecycle(coupon, now) === value).length;
    return <Box sx={{mb: 2}}>
        <Box sx={{display: "flex", flexWrap: "wrap", gap: 1.5, mb: 1}}>
            <TextField size="small" label={t("CouponSearchCode")} value={search} onChange={event => setSearch(event.target.value)}
                sx={{flex: "1 1 220px", minWidth: 0}}/>
            <TextField size="small" select label={t("CouponLifecycle")} value={status} onChange={event => setStatus(event.target.value)}
                sx={{flex: "1 1 200px", minWidth: 0}}>
                {COUPON_STATUSES.map(value => <MenuItem key={value} value={value}>{t(`CouponLifecycle_${value}`)} ({count(value)})</MenuItem>)}
            </TextField>
            {(search || status !== "ALL") && <Button onClick={() => { setSearch(""); setStatus("ALL"); }}>{t("CouponClearFilters")}</Button>}
        </Box>
        <Typography variant="body2" role="status">{t("Showing")} {visible} {t("of")} {coupons.length} {t("Coupons")}</Typography>
        <Typography variant="caption" color="text.secondary">{t("CouponScheduleHelp", {zone: Intl.DateTimeFormat().resolvedOptions().timeZone})}</Typography>
    </Box>;
}
